const AuthHeader = ({ title, children }) => {
    return (
        <>
            <div className='uppercase center'>
                <h2>{title}</h2>
            </div>
            {children}
        </>
    );
};

export default AuthHeader;
